<template>
  <DefaultLayout class="FeedView">
    <h1 class="mb-4 display-1">
      Обратная связь
    </h1>
    <p :class="$vuetify.breakpoint.smAndDown ? 'mb-8' : 'mb-3'">
      У вас возникла проблема, пожелание или предложение?
      Напишите нам в чат поддержки!
      <VBtn
        text
        href="https://b24.it-solution.ru/online/timeroot"
        target="_blank"
        class="primary"
        small
        :block="$vuetify.breakpoint.smAndDown"
        v-text="'Открыть чат в новом окне'"
      />
    </p>

    <iframe
      v-if="$vuetify.breakpoint.mdAndUp"
      src="https://b24.it-solution.ru/online/timeroot"
      style="border: 0; width: 100%; height: 750px"
    />

    <h2 class="mb-4 headline">
      Все контакты
    </h2>
    <VList dense>
      <VListItem
        href="skype:itsolutionteam?chat"
      >
        <VListItemIcon class="mr-4">
          <VImg
            :src="require('../assets/skype-logo.svg')"
            :max-width="24"
            class="ml-4"
          />
        </VListItemIcon>
        <VListItemContent>
          itsolutionteam
        </VListItemContent>
      </VListItem>
      <VListItem
        href="tel:+7-812-332-84-32"
      >
        <VListItemIcon class="mr-4">
          <VIcon
            class="ml-4 primary--text"
            v-text="'mdi-phone'"
          />
        </VListItemIcon>
        <VListItemContent>
          +7 (812) 332-84-32
        </VListItemContent>
      </VListItem>
      <VListItem
        href="mailto:info@it-solution.ru"
      >
        <VListItemIcon class="mr-4">
          <VIcon
            class="ml-4 primary--text"
            v-text="'mdi-email'"
          />
        </VListItemIcon>
        <VListItemContent>
          info@it-solution.ru
        </VListItemContent>
      </VListItem>
      <VListItem
        href="https://vk.com/itsolution_crm"
        target="_blank"
      >
        <VListItemIcon class="mr-0">
          <VImg
            :src="require('../assets/vk-logo.svg')"
            :max-width="52"
            class="ml-1"
          />
        </VListItemIcon>
        <VListItemContent>
          IT-Solution, страница VK
        </VListItemContent>
      </VListItem>
      <VListItem
        href="https://www.facebook.com/itsolution.team24x7/"
        target="_blank"
      >
        <VListItemIcon class="mr-4">
          <VImg
            :src="require('../assets/fb-logo.png')"
            :max-width="24"
            class="ml-4"
          />
        </VListItemIcon>
        <VListItemContent>
          IT-Solution, страница в Facebook
        </VListItemContent>
      </VListItem>
      <VListItem
        href="https://it-solution.ru/"
        target="_blank"
      >
        <VListItemIcon class="mr-2">
          <VImg
            :src="require('../assets/its-logo.svg')"
            :max-width="36"
            class="ml-3"
          />
        </VListItemIcon>
        <VListItemContent>
          IT-Solution, сайт разработчика
        </VListItemContent>
      </VListItem>
      <VListItem
        href="https://www.youtube.com/channel/UCyDsFD-cOQab8qckq-mCLiQ"
        target="_blank"
      >
        <VListItemContent>
          <VImg
            :src="require('../assets/yt-logo.png')"
            :max-width="80"
            class="ml-4"
          />
        </VListItemContent>
      </VListItem>
    </VList>
  </DefaultLayout>
</template>

<script>
// @ is an alias to /src
import DefaultLayout from '../layouts/Default'

export default {
  name: 'Contacts',
  components: {
    DefaultLayout,
  },
}
</script>
